module.exports = __webpack_public_path__ + "static/media/view3.8cd51a6c.jpg";